import apiClient from "./apiClient";

export const createCategory = (formData) => {
  return apiClient.post('/Category/Create', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};


export const getAllCategories = () => {
  return apiClient.get('/Admin/Categories');
};

export const updateCategory = (id, formData) => {
  return apiClient.put(`/Admin/Category/Update/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const deleteCategory = (id) => {
  return apiClient.delete(`/Admin/Category/Delete/${id}`);
};


export const getCategoryOptions = (categoryId) => {
  return apiClient.get(`/Category/Option/${categoryId}`);
};

export const createCategoryOption = (formData) => {
  return apiClient.post('/Category/Option/Create', formData);
};

export const updateCategoryOption = (id, formData) => {
  return apiClient.put(`/Category/Option/Update/${id}`, formData);
};

export const deleteCategoryOption = (id) => {
  return apiClient.delete(`/Category/Option/Delete/${id}`);
};

export const createCms = (formData) => {
  return apiClient.post('/Cms/Create', formData);
};

export const getAllCms = () => {
  return apiClient.get('/Cms/All');
};

export const getCms = (categoryId, optionId, plan) => {
  const params = new URLSearchParams();
  if (categoryId) params.append('categoryId', categoryId);
  if (optionId) params.append('optionId', optionId);
  if (plan) params.append('plan', plan);

  const queryString = params.toString();
  return apiClient.get(`/Cms${queryString ? `?${queryString}` : ''}`);
};


export const updateCms = (id, formData) => {
  return apiClient.put(`/Cms/Update/${id}`, formData);
};

export const deleteCms = (id) => {
  return apiClient.delete(`/Cms/Delete/${id}`);
};


